
import Vue, { PropType } from 'vue';

import Table from '@/components/common/Table.vue';
import ConfirmActionModal from '@/components/modal/ConfirmActionModal.vue';
import { BvTableFieldArray } from 'bootstrap-vue/src/components/table';
import { DeviceRow } from '@/views/configuration/DeviceListView.vue';

export default Vue.extend({
	name: 'SiteLuminaireList',

	components: {
		Table,
		ConfirmActionModal,
	},

	data(): {
		luminaireCategory: string | null;
		luminaireName: string | null;
		controllerName: string | null;
		luminaireId: number | null;
		controllerId: number | null;
	} {
		return {
			luminaireCategory: null,
			luminaireName: null,
			controllerName: null,
			luminaireId: null,
			controllerId: null,
		};
	},

	computed: {
		fields(): BvTableFieldArray {
			return [
				{
					key: 'name',
					label: this.$i18n.t('Name').toString(),
					sortable: true,
					thClass: 'name-column-width',
					tdClass: 'name-column-width',
				},
				{
					key: 'type',
					label: this.$i18n.t('Type').toString(),
					sortable: true,
					thClass: 'table-column-width',
					tdClass: 'table-column-width',
				},
				{
					key: 'floor',
					label: this.$i18n.t('Floor').toString(),
					sortable: true,
					thClass: 'table-column-width',
					tdClass: 'table-column-width',
				},
				{
					key: 'room',
					label: this.$i18n.t('Room').toString(),
					sortable: true,
					thClass: 'table-column-width',
					tdClass: 'table-column-width',
				},
				{
					key: 'zone',
					label: this.$i18n.t('Zone').toString(),
					sortable: true,
					thClass: 'table-column-width',
					tdClass: 'table-column-width',
				},
				{
					key: 'controllerVersion',
					label: this.$i18n.t('Version').toString(),
					sortable: true,
					thClass: 'table-column-width',
					tdClass: 'table-column-width',
				},
				{
					key: 'channel',
					label: this.$i18n.t('Channel').toString(),
					sortable: true,
					thClass: 'table-column-width',
					tdClass: 'table-column-width',
				},
				{
					key: 'off',
					label: this.$i18n.t('Off').toString(),
					sortable: false,
				},
				{
					key: 'identify',
					label: this.$i18n.t('Identify').toString(),
					sortable: false,
				},
				{
					key: 'emerSwRule',
					label: this.$i18n.t('EmerSwRuleName').toString(),
					sortable: false,
					thClass: 'table-column-width',
					tdClass: 'table-column-width',
				},
				{
					key: 'appliedRule',
					label: this.$i18n.t('Rule').toString(),
					sortable: true,
					thClass: 'table-column-width',
					tdClass: 'table-column-width',
				},
				{
					key: 'offset',
					label: this.$i18n.t('offset').toString(),
					sortable: true,
					thClass: 'table-column-width',
					tdClass: 'table-column-width',
				},
				{ key: 'delete', label: '', thClass: 'outline-disable' },
			];
		},
	},

	props: {
		luminaires: {
			type: Array as PropType<DeviceRow[]>,
			default: (): DeviceRow[] => [],
		},
		userPermission: { type: Boolean, default: true },
		hasOffRule: { type: Boolean, default: true },
		hasIdentifyRule: { type: Boolean, default: true },
	},

	methods: {
		onModifyLuminaire(row: DeviceRow) {
			this.$emit('luminaireClicked', row);
		},

		changeOff(row: DeviceRow): void {
			this.$emit('changeOff', row.id, row.off);
		},

		changeIdentify(row: DeviceRow): void {
			this.$emit('changeIdentify', row.id, row.identify);
		},

		confirmLuminaireDeletion(row: DeviceRow): void {
			this.luminaireCategory = row.category;
			this.luminaireName = row.name;
			this.controllerName = row.controllerName;
			this.luminaireId = row.id;
			this.controllerId = row.controllerId;
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			(this.$refs.luminairesDeletionConfirmModal as any).show();
		},

		removeSelectedLuminaire(): void {
			this.luminaireCategory = null;
			this.luminaireName = null;
			this.controllerName = null;
			this.luminaireId = null;
			this.controllerId = null;
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			(this.$refs.luminairesDeletionConfirmModal as any).hide();
		},

		deleteLuminaire(): void {
			this.$emit(
				'removeLuminaire',
				{
					selectedDeviceId: this.luminaireId,
					selectedControllerId: this.controllerId,
					selectedCategory: this.luminaireCategory,
				},
				'deleteLuminaire'
			);
			this.removeSelectedLuminaire();
		},
	},
});
